<template>
  <v-container
    id="register"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                <v-icon left>
                  mdi-view-dashboard
                </v-icon>
                Tableau de bord Happy Quest
                <v-icon right>
                  mdi-view-dashboard
                </v-icon>
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <div class="text-center grey--text body-1 font-weight-bold">
              Nouveau mot de passe
            </div>

            <!-- Formulaire -->
            <v-form
              v-if="!isLoading"
              v-model="isValid"
            >
              <v-text-field
                v-model="password"
                color="secondary"
                label="Mot de passe..."
                :rules="[rules.required, rules.minLength]"
                type="password"
                hide-details="auto"
                prepend-icon="mdi-lock"
                required
              />

              <v-text-field
                v-model="passwordCheck"
                color="secondary"
                label="Vérification du mot de passe..."
                :rules="[rules.required, rules.pwdMatch]"
                type="password"
                hide-details="auto"
                prepend-icon="mdi-lock"
                required
              />

              <p
                v-if="error.hasError"
                class="title text-uppercase error--text"
              >
                {{ error.errorMsg }}
              </p>

              <div class="my-2">
                <v-btn
                  class="ma-2"
                  outlined
                  color="primary"
                  :disabled="!isValid"
                  @click="handleFormSubmit"
                >
                  Changer le mot de passe
                  <v-icon right>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </div>
            </v-form>
            <!-- Affichage du chargement -->
            <v-row
              v-else
              justify="center"
            >
              <circle10 />
            </v-row>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import { Circle10 } from 'vue-loading-spinner'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'NewPassword',

    /* Sous-composants utilisés par ce composant */
    components: {
      Circle10,
    },

    /* Paramètres */
    props: {
      email: {
        type: String,
        default: '',
      },
      token: {
        type: String,
        default: '',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        password: '',
        passwordCheck: '',
        isValid: false,
        isLoading: false,
        error: {
          hasError: false,
          errorMsg: '',
        },
        rules: {
          minLength: value => (value.length >= 4) || 'Ce champ contient 4 caractères minimum.',
          required: value => !!value || 'Ce champ ne peut être vide.',
          pwdMatch: value => value === this.password || 'Les mots de passe doivent être identiques.',
        },
      }
    },

    /* Fonctions internes */
    methods: {
      handleFormSubmit: function () {
        this.isLoading = true
        this.$Auth.httpRequest('post', 'passwordForgotten', {
          email: this.email,
          token: this.token,
          password: this.password,
        })
          .then(res => {
            this.$router.push({ name: 'Redirection New Password' })
          })
          .catch(err => {
            this.error.hasError = true
            this.error.errorMsg = err.response.data
            this.password = ''
            this.passwordCheck = ''
          }).finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>
